export default "__VITE_ASSET__78cb861d__"